import { useCallback, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import ToastContext from './toastContext';
import Toast from './Toast';

const AUTO_DISMISS_MS = 4000; // >= 3000ms per design charter

// Mounts the fixed toast layer (top-center, z-toast) and provides the
// useToast() API. Messages are caller-translated strings; errors that
// require action belong inline (Alert), not here.
export default function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(1);

  const push = useCallback((kind, message) => {
    const id = nextId.current;
    nextId.current += 1;
    setToasts((list) => [...list, { id, kind, message }]);
    setTimeout(() => {
      setToasts((list) => list.filter((item) => item.id !== id));
    }, AUTO_DISMISS_MS);
  }, []);

  const api = useMemo(
    () => ({
      success: (message) => push('success', message),
      error: (message) => push('error', message),
      info: (message) => push('info', message),
    }),
    [push]
  );

  return (
    <ToastContext.Provider value={api}>
      {children}
      {createPortal(
        <div className="toast-layer" role="status" aria-live="polite">
          {toasts.map((item) => <Toast key={item.id} kind={item.kind} message={item.message} />)}
        </div>,
        document.body
      )}
    </ToastContext.Provider>
  );
}
